import { showWarningAsync } from 'notification/store/thunks';
import { createExpertiseResponseAction } from './actions';
import { buildLoggerForStore } from 'logging/writers/utils';
import { RpcRequestHandlers } from 'widgets/store/rpcStream/handlers';
import { ExpertiseResponse } from 'communication/types/expertise/ExpertiseResponse';
import { ExpertiseWidgetType } from '../../ExpertiseWidgetStrategy';
import { StreamError } from 'streamsState/store/streamStatuses/StreamErrorState';
import { AnyAction, Store } from 'redux';
import { LoggingService } from '@instinet-analytics/core-lib';

const log = buildLoggerForStore('expertise');

export const buildExpertiseHandlers =
    (expertiseWidgetType: ExpertiseWidgetType) =>
    (
        widgetKey: string,
        store: Store,
        loggingService: LoggingService
    ): RpcRequestHandlers<ExpertiseResponse> => {
        const dispatch = store.dispatch;

        return {
            onSuccess: (response: ExpertiseResponse) => {
                dispatch(
                    createExpertiseResponseAction(expertiseWidgetType)(
                        widgetKey,
                        response
                    )
                );
            },
            onError: (err: StreamError) => {
                log.warn(loggingService, 'useExpertiseStreamHandlers', err);
                dispatch(
                    showWarningAsync(
                        'Error loading expertise data'
                    ) as unknown as AnyAction
                );
            },
        };
    };
